import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../store';
import Table from '../../../facturotopia/table/Table';

class EmpresasList extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: []
    }
  }

  get columns() {
    return [
      {
        key: 'nombre',
        title: 'Empresa',
        dataIndex: 'nombre',
      },
      {
        key: 'status',
        title: 'Status',
        dataIndex: 'status',
        render: (item) => {
          return <strong>{ item.status }</strong>
        }
      }
    ];
  }

  componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  paginate(page = 1) {
    this.props.paginate({
      page
    });
  }

  handleOnPageChange = (page) => {
    this.paginate(page);
  }

  handleRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selected: selectedRowKeys
    }, () => {
      const { onRowSelectionChange } = this.props;

      onRowSelectionChange && onRowSelectionChange({selectedRowKeys, selectedRows});
    });
  }

  getRowSelectionConfig = () => {
    return {
      type: 'checkbox',
      onChange: this.handleRowSelectionChange,
      getCheckboxProps: record => ({
        disabled: record.name === 'Disabled User', // Column uration not to be checked
        name: record.name,
      }),
    }
  }

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange
    }
  }

  render() {
    const { columns, selected } = this.state;
    const { data, busy } = this.props;
    const { onRowClick } = this.props;

    return (
      <Table
        loading={ busy }
        columns={ columns }
        rowKey={ 'id' }
        data={ data }
        pagination={ this.getPaginationConfig() }
        rowSelection={ {
          selectedRowKeys: selected,
            ...this.getRowSelectionConfig()
          }
        }
        onRowClick={ onRowClick }
      >
      </Table>
    )
  }
}

const mapState = (state) => {
  return state.cuenta.empresas.list;
}

const mapActions = (actions) => {
  return {
    paginate: actions.cuenta.empresas.list.paginate
  };
}

export default connect(useStore, mapState, mapActions)(EmpresasList);